import classNames from "classnames";
import { LoadingIcon } from "components/icons/LoadingIcon";
import { motion } from "framer-motion";

type LoaderProps = {
  addClassName?: string;
  size?: "regular" | "small";
  customType?: "primary" | "secondary";
};

export const Spinner = ({
  className = "",
  size = "regular",
}: { className?: string } & Pick<LoaderProps, "size">) => {
  return (
    <div
      className={classNames(
        `t-animate-spin t-border-[3px] t-border-purple-55 t-border-solid t-border-t-surface-transparent t-rounded-full`,
        `${className}`,
        {
          "t-h-4 t-w-4": size === "small",
          "t-h-11 t-w-11": size === "regular",
        }
      )}
    />
  );
};

const Loader = ({
  addClassName = "",
  size = "regular",
  customType = "primary",
}: {
  addClassName?: string;
  size?: "regular" | "small";
  customType?: "primary" | "secondary";
}) => {
  if (customType === "secondary") {
    return (
      <span
        data-testid="loader-v0"
        className="t-flex t-origin-center t-animate-spin t-text-neutral-70"
      >
        <LoadingIcon />
      </span>
    );
  }

  if (customType === "primary") {
    return (
      <motion.div
        data-testid="loader-v0"
        id="loader-v0"
        layout
        className={classNames(
          `t-flex t-justify-center t-items-center ${addClassName}`,
          {
            "t-h-[580px]": size === "regular",
            "t-h-4": size === "small",
          }
        )}
      >
        <Spinner size={size} />
      </motion.div>
    );
  }
  return null;
};

export const CenteredLoader = () => (
  <div className="t-flex t-h-full t-w-full t-items-center t-justify-center">
    <Loader />
  </div>
);

export default Loader;
